import { MAC_DMG_URL } from '@/lib/config'
import { isDesktopShell } from '@/lib/desktopShell'

/** Les apps Callizy : magasins mobiles (mêmes liens que le site) et l'app Mac. */
export const APP_STORE_URL = 'https://apps.apple.com/ca/app/callizy/id6755805657'
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.callizy.softphone'
export const MAC_APP_URL = MAC_DMG_URL

/** Sur un Mac, hors de l'app Mac elle-même. */
export function surMacSansApp(): boolean {
  return /Macintosh/i.test(navigator.userAgent || '') && !isDesktopShell()
}

/** Le magasin de l'appareil courant, ou null sur ordinateur. */
export function lienMagasinDuTelephone(): string | null {
  const ua = navigator.userAgent || ''
  if (/iPhone|iPad|iPod/i.test(ua)) return APP_STORE_URL
  if (/Android/i.test(ua)) return PLAY_STORE_URL
  return null
}
